import React from 'react';

import styles from './styles.module.scss';

/**
 * HairstyleWomenLayout — isolated shell for the HairstyleWomen face-rating funnel.
 * Dark violet→magenta gradient background + a centered mobile container.
 * Each screen draws its own header / progress / button, so no shared chrome here.
 */
const HairstyleWomenLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.root}>
    <div className={styles.bg} aria-hidden="true" />
    <div className={styles.container}>{children}</div>
  </div>
);

export default HairstyleWomenLayout;
